// ============================================================
// Shared Icons
// ============================================================

import type { Component } from 'solid-js'

// File Upload Icon
export const FileUpload: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
)

// Music/Note Icon
export const MusicNote: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M9 18V5l12-2v13" />
    <circle cx="6" cy="18" r="3" />
    <circle cx="18" cy="16" r="3" />
  </svg>
)

// Settings Icon
export const Settings: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
)

// Loader/Spinner Icon
export const Loader2: Component = () => (
  <svg
    class="icon-spin"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
  </svg>
)

// Check Circle Icon
export const CheckCircle: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
)

// X Circle Icon (Error)
export const XCircle: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="15" y1="9" x2="9" y2="15" />
    <line x1="9" y1="9" x2="15" y2="15" />
  </svg>
)

// Pause Icon
export const Pause: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <rect x="6" y="4" width="4" height="16" />
    <rect x="14" y="4" width="4" height="16" />
  </svg>
)

// Play Icon
export const Play: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <polygon points="5 3 19 12 5 21 5 3" />
  </svg>
)

// X Icon
export const X: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
)

// Lock — protected supporter content
export const Lock: Component<{ size?: number }> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width={props.size ?? 24}
    height={props.size ?? 24}
    aria-hidden="true"
  >
    <rect x="5" y="10" width="14" height="10" rx="2" />
    <path d="M8 10V7a4 4 0 0 1 8 0v3" />
  </svg>
)

// Download Icon
// Cloud — a song the account knows about but this device does not hold.
// Not Download: nothing is downloading, and offering that arrow would
// promise a button the library cannot honour until a transport exists.
export const Cloud: Component<{ size?: number }> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    width={props.size ?? 24}
    height={props.size ?? 24}
    aria-hidden="true"
    data-icon="cloud"
  >
    <path d="M7 18.5a4 4 0 0 1-.6-7.95 5.5 5.5 0 0 1 10.7-1.6A4.25 4.25 0 0 1 17.5 18.5z" />
  </svg>
)

export const Download: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
)

// Install App Icon — a handset taking an arrow, for "add this to your device".
// Distinct from Download on purpose: Download means a file lands in your
// downloads folder, this means the app lands on your home screen.
export const InstallApp: Component<{ size?: number }> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width={props.size ?? 24}
    height={props.size ?? 24}
    aria-hidden="true"
  >
    <rect x="5" y="2" width="14" height="20" rx="2.5" />
    <line x1="12" y1="7" x2="12" y2="14" />
    <polyline points="9 11 12 14 15 11" />
  </svg>
)

// iOS Share Icon — the glyph in Safari's toolbar, so the Add to Home Screen
// hint can point at something the user can actually recognise.
export const IosShare: Component<{ size?: number }> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width={props.size ?? 24}
    height={props.size ?? 24}
    aria-hidden="true"
  >
    <path d="M8 11H6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-2" />
    <line x1="12" y1="14" x2="12" y2="3" />
    <polyline points="8 7 12 3 16 7" />
  </svg>
)

// File Text Icon
export const FileText: Component<{ size?: number }> = (p) => (
  <svg
    width={p.size ?? 24}
    height={p.size ?? 24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
)

// Music Icon
export const Music: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M9 18V5l12-2v13" />
    <circle cx="6" cy="18" r="3" />
    <circle cx="18" cy="16" r="3" />
  </svg>
)

// Piano keys — shared by the app practice context and Piano Night surfaces.
export const PianoKeys: Component<{ size?: number; class?: string }> = (
  props,
) => (
  <svg
    class={props.class}
    viewBox="0 0 24 24"
    width={props.size ?? 24}
    height={props.size ?? 24}
    fill="none"
    stroke="currentColor"
    stroke-width="1.6"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M8 5v9M12 5v9M16 5v9" stroke-width="1.3" />
  </svg>
)

// Crosshair Icon
export const Crosshair: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <circle cx="12" cy="12" r="8" />
    <line x1="12" y1="2" x2="12" y2="6" />
    <line x1="12" y1="18" x2="12" y2="22" />
    <line x1="2" y1="12" x2="6" y2="12" />
    <line x1="18" y1="12" x2="22" y2="12" />
  </svg>
)

// Sliders Horizontal Icon
export const SlidersHorizontal: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <line x1="4" y1="21" x2="4" y2="14" />
    <line x1="4" y1="10" x2="4" y2="3" />
    <line x1="12" y1="21" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12" y2="3" />
    <line x1="20" y1="21" x2="20" y2="16" />
    <line x1="20" y1="12" x2="20" y2="3" />
    <circle cx="4" cy="14" r="2" />
    <circle cx="12" cy="8" r="2" />
    <circle cx="20" cy="16" r="2" />
  </svg>
)

// History Icon
export const History: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
)

// Chevron Down Icon
export const ChevronDown: Component<{ size?: number }> = (p) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width={p.size ?? 24}
    height={p.size ?? 24}
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
)

// Chevron Left Icon
export const ChevronLeft: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <polyline points="15 18 9 12 15 6" />
  </svg>
)

// Chevron Up Icon
export const ChevronUp: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <polyline points="18 15 12 9 6 15" />
  </svg>
)

// Voice/Speech Icon (for vocal)
export const Voice: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
    <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
    <line x1="12" y1="19" x2="12" y2="23" />
    <line x1="8" y1="23" x2="16" y2="23" />
  </svg>
)

// Headphones Icon (for instrumental)
export const Headphones: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
    <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
  </svg>
)

// Crossed headphones indicate that input monitoring is off.
export function HeadphonesOff() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      width="24"
      height="24"
    >
      <path d="M3 18v-6a9 9 0 0 1 1.2-4.5M7.1 4.4A9 9 0 0 1 21 12v3" />
      <path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM16 16v3a2 2 0 0 0 2 2h1" />
      <path d="m2 2 20 20" />
    </svg>
  )
}

// MIDI Icon (for MIDI files)
export const Midi: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M9 18V5l12-2v13" />
    <path d="M9 18c0 1.1 2.5 2 5.5 2 3 0 5.5-.9 5.5-2" />
    <path d="M9 11c0 1.1 2.5 2 5.5 2 3 0 5.5-.9 5.5-2" />
    <circle cx="6" cy="18" r="3" />
    <circle cx="18" cy="16" r="3" />
  </svg>
)

// Music Board Icon (for full mix)
export const MusicBoard: Component<{ size?: number }> = (p) => (
  <svg
    width={p.size ?? 24}
    height={p.size ?? 24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <line x1="9" y1="3" x2="9" y2="21" />
    <line x1="15" y1="3" x2="15" y2="21" />
    <circle cx="9" cy="18" r="3" />
    <circle cx="15" cy="18" r="3" />
    <circle cx="12" cy="8" r="2" />
  </svg>
)

// Score document — one staged piece or track, never a library container.
export const ScoreDocument: Component<{ size?: number }> = (props) => (
  <svg
    width={props.size ?? 24}
    height={props.size ?? 24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    data-icon="score-document"
  >
    <path d="M6 2.75h7.6L18 7.15V21.25H6z" />
    <path d="M13.5 2.9v4.5H18" />
    <path d="M8.6 11.1h6.8M8.6 14.15h6.8M8.6 17.2h6.8" />
    <path d="M11.1 10.2v5.15" />
    <ellipse cx="9.7" cy="15.85" rx="1.4" ry="1.05" />
  </svg>
)

// Guitar tab — six strings with fret numbers on them, the notation this room
// reads. Distinct from ScoreDocument, which is a page of staff notation.
export const GuitarTab: Component<{ size?: number }> = (props) => (
  <svg
    width={props.size ?? 24}
    height={props.size ?? 24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    data-icon="guitar-tab"
  >
    <path d="M3.25 6h17.5M3.25 9.5h17.5M3.25 13h17.5M3.25 16.5h17.5M3.25 20h17.5" />
    <path d="M6.4 6h2.6M13.2 9.5h2.4M9.1 16.5h2.6" stroke-width="3.4" />
  </svg>
)

// Music library — the device-local collection used to choose a staged piece.
export const MusicLibrary: Component<{ size?: number }> = (props) => (
  <svg
    width={props.size ?? 24}
    height={props.size ?? 24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    data-icon="music-library"
  >
    <path d="M3.25 7.25h6l1.8 2H20.75v9.5a2 2 0 0 1-2 2H5.25a2 2 0 0 1-2-2z" />
    <path d="M3.25 7.25V5.2a2 2 0 0 1 2-2h4.1l1.8 2H18a2 2 0 0 1 2 2v2.05" />
    <path d="M14.25 17v-4.1l3.25-.65v3.85" />
    <ellipse cx="12.85" cy="17.2" rx="1.4" ry="1.05" />
    <ellipse cx="16.1" cy="16.3" rx="1.4" ry="1.05" />
  </svg>
)

// Piano workspace — the full editor reached from a standalone Piano room.
export const PianoWorkspace: Component<{ size?: number }> = (props) => (
  <svg
    width={props.size ?? 24}
    height={props.size ?? 24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    data-icon="piano-workspace"
  >
    <rect x="2.75" y="3.25" width="18.5" height="17.5" rx="2.5" />
    <path d="M2.9 8h18.2M6.5 4.9h.01M9 4.9h.01" />
    <path d="M6 11.25v6.5M9 11.25v6.5M12 11.25v6.5M15 11.25v6.5M18 11.25v6.5" />
    <path d="M7.5 11.25v3.35M10.5 11.25v3.35M13.5 11.25v3.35M16.5 11.25v3.35" />
  </svg>
)

/** Playlist — a list with a music note (for the Playlists tab). */
export const Playlist: Component<{ size?: number }> = (p) => (
  <svg
    width={p.size ?? 24}
    height={p.size ?? 24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <line x1="3" y1="6" x2="14" y2="6" />
    <line x1="3" y1="12" x2="14" y2="12" />
    <line x1="3" y1="18" x2="10" y2="18" />
    <circle cx="16" cy="18" r="2.5" />
    <path d="M18.5 18V8" />
  </svg>
)

// Calendar Icon (for dates)
export const Calendar: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
)

// Box/Package Icon (for file size)
// Trash2 Icon
export const Trash2: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <line x1="10" y1="11" x2="10" y2="17" />
    <line x1="14" y1="11" x2="14" y2="17" />
  </svg>
)

export const AlertTriangle: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
)

export const Box: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
    <line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
)

// Volume2 Icon (speaker with sound waves)
export const Volume2: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
    <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
    <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
  </svg>
)

// VolumeX Icon (muted speaker)
export const VolumeX: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
    <line x1="23" y1="9" x2="17" y2="15" />
    <line x1="17" y1="9" x2="23" y2="15" />
  </svg>
)

// SkipBack Icon (restart/previous)
export const SkipBack: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <polygon points="19 20 9 12 19 4 19 20" />
    <line x1="5" y1="19" x2="5" y2="5" />
  </svg>
)

// SkipForward Icon (next)
export const SkipForward: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <polygon points="5 4 15 12 5 20 5 4" />
    <line x1="19" y1="5" x2="19" y2="19" />
  </svg>
)

// RotateCcw Icon (restart / refresh)
export const RotateCcw: Component<{ size?: number }> = (p) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width={p.size ?? 24}
    height={p.size ?? 24}
  >
    <polyline points="1 4 1 10 7 10" />
    <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
  </svg>
)

// Share Icon
export const Share: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
  </svg>
)

// Mic Icon
export const Mic: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
    <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
    <line x1="12" y1="19" x2="12" y2="23" />
    <line x1="8" y1="23" x2="16" y2="23" />
  </svg>
)

// MicFilled — the mic that is hearing the singer now: Mic with its capsule
// filled, as a premium room's mic draws it on the singer's turn (room kit,
// RoomControls.tsx). Labelled by its button, so hidden here.
export const MicFilled: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
    aria-hidden="true"
  >
    <path
      d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"
      fill="currentColor"
    />
    <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
    <line x1="12" y1="19" x2="12" y2="23" />
    <line x1="8" y1="23" x2="16" y2="23" />
  </svg>
)

// Plus Icon — add
export const Plus: Component<{ size?: number }> = (p) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width={p.size ?? 24}
    height={p.size ?? 24}
  >
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
)

// Minus Icon — the counterpart to Plus (zoom out, decrement). Same geometry
// and stroke weight so a plus/minus pair reads as one control, not two.
export const Minus: Component<{ size?: number }> = (p) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width={p.size ?? 24}
    height={p.size ?? 24}
  >
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
)

// Repeat / Replace Icon — swap a stem for a new one
export const Repeat: Component<{ size?: number }> = (p) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width={p.size ?? 24}
    height={p.size ?? 24}
  >
    <polyline points="17 1 21 5 17 9" />
    <path d="M3 11V9a4 4 0 0 1 4-4h14" />
    <polyline points="7 23 3 19 7 15" />
    <path d="M21 13v2a4 4 0 0 1-4 4H3" />
  </svg>
)

// Search Icon — magnifier (session search)
export const Search: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
)

// Trophy Icon — used for the karaoke playlist scoreboard
export const Trophy: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
    <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
    <path d="M4 22h16" />
    <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
    <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
    <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
  </svg>
)

// SingMic Icon — microphone with sound wave arcs (Shazam-style recognition)
export const SingMic: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M12 2a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z" />
    <path d="M18 9v2a6 6 0 0 1-12 0V9" />
    <line x1="12" y1="17" x2="12" y2="20" />
    <line x1="9" y1="20" x2="15" y2="20" />
    {/* Sound wave arcs */}
    <path d="M19 6a5.5 5.5 0 0 1 0 8" stroke-width="1.5" opacity="0.7" />
    <path d="M21.5 4a9 9 0 0 1 0 12" stroke-width="1.5" opacity="0.45" />
  </svg>
)

// FilePlus Icon (new session — document with plus badge)
export const FilePlus: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="12" y1="18" x2="12" y2="12" />
    <line x1="9" y1="15" x2="15" y2="15" />
  </svg>
)

// Sparkles Icon (magic/fresh-start)
export const Sparkles: Component<{ size?: number }> = (p) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width={p.size ?? 24}
    height={p.size ?? 24}
  >
    <path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5z" />
    <path d="M18 16l1 3 3 1-3 1-1 3-1-3-3-1 3-1z" />
    <path d="M6 3l.5 1.5L8 5l-1.5.5L6 7l-.5-1.5L4 5l1.5-.5z" />
  </svg>
)

// Ear Icon (solo)
export const Ear: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0" />
    <path d="M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4" />
  </svg>
)

// CPU Icon
export const Cpu: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <rect x="4" y="4" width="16" height="16" rx="2" ry="2" />
    <rect x="9" y="9" width="6" height="6" />
    <line x1="9" y1="1" x2="9" y2="4" />
    <line x1="15" y1="1" x2="15" y2="4" />
    <line x1="9" y1="20" x2="9" y2="23" />
    <line x1="15" y1="20" x2="15" y2="23" />
    <line x1="20" y1="9" x2="23" y2="9" />
    <line x1="20" y1="14" x2="23" y2="14" />
    <line x1="1" y1="9" x2="4" y2="9" />
    <line x1="1" y1="14" x2="4" y2="14" />
  </svg>
)

// Zap Icon (Lightning)
export const Zap: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
)

// Server Icon
export const Server: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <rect x="2" y="2" width="20" height="8" rx="2" ry="2" />
    <rect x="2" y="14" width="20" height="8" rx="2" ry="2" />
    <line x1="6" y1="6" x2="6.01" y2="6" />
    <line x1="6" y1="18" x2="6.01" y2="18" />
  </svg>
)

// Clock Icon
export const Clock: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
)

// Export File Icon (download arrow into tray)
export const ExportFile: Component = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
  </svg>
)

// Export Group Icon (folder with download arrow)
export const ExportGroup: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
    <line x1="12" y1="11" x2="12" y2="17" />
    <polyline points="9 14 12 17 15 14" />
  </svg>
)

// Import File Icon (upload arrow into tray)
export const ImportFile: Component = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
    <path d="M9 16h6v-6h4l-7-7-7 7h4v6zm-4 2h14v2H5z" />
  </svg>
)

// Metronome Icon
export const Metronome: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M12 2 8 22h8L12 2z" />
    <path d="M12 7.5 14.5 17.5h-5z" />
  </svg>
)

// Stop Icon (end a take)
export const RecordCircle: Component = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <circle cx="12" cy="12" r="7" />
  </svg>
)

export const Square: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <rect x="6" y="6" width="12" height="12" rx="1.5" />
  </svg>
)

// Waveform Bars Icon (audio visualization)
// Mercury — the planet, carrying the brand's own waterline.
//
// Drawn rather than generated: an icon has to read at 20px in one colour and
// sit beside the rest of this set, which a rendered image cannot do. The
// shapes are the brand mark's (public/brand-mark.svg) reduced to strokes —
// the orb, a single pitch wave across it as the meniscus, and the tilted
// orbit that says planet rather than ball.
export const MercuryPlanet: Component<{ size?: number }> = (p) => (
  <svg
    width={p.size ?? 24}
    height={p.size ?? 24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="12" cy="12" r="7" />
    {/* The waterline: one pitch wave, clipped to the orb so it reads as
        liquid held inside rather than a line drawn over the top. */}
    <clipPath id="mercury-orb">
      <circle cx="12" cy="12" r="7" />
    </clipPath>
    <path
      d="M4 13.2c1.8 0 2-2.6 4-2.6s2.2 2.6 4 2.6 2-2.6 4-2.6 2.2 2.6 4 2.6"
      clip-path="url(#mercury-orb)"
    />
    {/* Orbit, tilted and open at the ends so the planet sits in front of it. */}
    <path
      d="M5.2 7.2C2.6 8 1 9.3 1.2 10.6c.2 1.4 2.6 2.2 5.6 2"
      opacity="0.75"
    />
    <path
      d="M18.8 16.8c2.6-.8 4.2-2.1 4-3.4-.2-1.4-2.6-2.2-5.6-2"
      opacity="0.75"
    />
  </svg>
)

export const WaveformBars: Component<{ size?: number }> = (p) => (
  <svg
    width={p.size ?? 24}
    height={p.size ?? 24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M3 9h2v6H3zM7 6h2v12H7zM11 12h2v3h-2zM15 9h2v6h-2zM19 7h2v10h-2z" />
  </svg>
)

// Magnifying Glass Icon (search/zoom)
export const MagnifyingGlass: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.35-4.35" />
  </svg>
)

// Eye Icon (visibility)
export const Eye: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
)

// Eye-Off Icon (hidden / visibility toggled off)
export const EyeOff: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
)

// MIDI DIN Connector Icon
export const MidiDin: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="3" />
    <circle cx="12" cy="5" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="18.7" cy="7.7" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="16.2" cy="16.2" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="7.8" cy="16.2" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="5.3" cy="7.7" r="1.5" fill="currentColor" stroke="none" />
  </svg>
)

// DeleteGroup Icon (folder with X -- delete group and its sessions)
export const DeleteGroup: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
    <line x1="9" y1="12" x2="15" y2="18" />
    <line x1="15" y1="12" x2="9" y2="18" />
  </svg>
)

// CheckSmall Icon (simple checkmark — confirm/save)
export const CheckSmall: Component<{ size?: number }> = (p) => (
  <svg
    width={p.size ?? 14}
    height={p.size ?? 14}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
)

// MoreHorizontal Icon — the "more" trigger on a row of controls, where the
// dots read as "the row continues" rather than as a stacked menu.
export const MoreHorizontal: Component<{ size?: number }> = (p) => (
  <svg
    width={p.size ?? 16}
    height={p.size ?? 16}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    aria-hidden="true"
  >
    <circle cx="5" cy="12" r="1.9" fill="currentColor" stroke="none" />
    <circle cx="12" cy="12" r="1.9" fill="currentColor" stroke="none" />
    <circle cx="19" cy="12" r="1.9" fill="currentColor" stroke="none" />
  </svg>
)

// MoreVertical Icon (kebab menu trigger)
export const MoreVertical: Component<{ size?: number }> = (p) => (
  <svg
    width={p.size ?? 16}
    height={p.size ?? 16}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="12" cy="5" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" />
    <circle cx="12" cy="19" r="1.5" fill="currentColor" stroke="none" />
  </svg>
)

// Pencil Icon (edit/rename)
export const Pencil: Component<{ size?: number }> = (p) => (
  <svg
    width={p.size ?? 14}
    height={p.size ?? 14}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
    <path d="m15 5 4 4" />
  </svg>
)

// Maximize2 / Minimize2 — enter/exit fullscreen (karaoke focus mode)
export const Maximize2: Component<{ size?: number }> = (p) => (
  <svg
    width={p.size ?? 16}
    height={p.size ?? 16}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <polyline points="15 3 21 3 21 9" />
    <polyline points="9 21 3 21 3 15" />
    <line x1="21" y1="3" x2="14" y2="10" />
    <line x1="3" y1="21" x2="10" y2="14" />
  </svg>
)

export const Minimize2: Component<{ size?: number }> = (p) => (
  <svg
    width={p.size ?? 16}
    height={p.size ?? 16}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <polyline points="4 14 10 14 10 20" />
    <polyline points="20 10 14 10 14 4" />
    <line x1="14" y1="10" x2="21" y2="3" />
    <line x1="3" y1="21" x2="10" y2="14" />
  </svg>
)

// Loop Icon (repeat/cycle)
export const Loop: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M17 2l4 4-4 4" />
    <path d="M3 11V9a4 4 0 014-4h14" />
    <path d="M7 22l-4-4 4-4" />
    <path d="M21 13v2a4 4 0 01-4 4H3" />
  </svg>
)

export const GripVertical: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="9" cy="12" r="1" />
    <circle cx="9" cy="5" r="1" />
    <circle cx="9" cy="19" r="1" />
    <circle cx="15" cy="12" r="1" />
    <circle cx="15" cy="5" r="1" />
    <circle cx="15" cy="19" r="1" />
  </svg>
)

// Split a note (divide at a point)
export const Split: Component<{ size?: number }> = (p) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width={p.size ?? 24}
    height={p.size ?? 24}
  >
    <rect x="3" y="9" width="7" height="6" rx="1.5" />
    <rect x="14" y="9" width="7" height="6" rx="1.5" />
    <line x1="12" y1="4" x2="12" y2="20" stroke-dasharray="2 2" />
  </svg>
)

// Merge two notes into one
export const Merge: Component<{ size?: number }> = (p) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width={p.size ?? 24}
    height={p.size ?? 24}
  >
    <rect x="2" y="9" width="6" height="6" rx="1.5" />
    <rect x="16" y="9" width="6" height="6" rx="1.5" />
    <line x1="8" y1="12" x2="16" y2="12" />
    <polyline points="13 9 16 12 13 15" />
  </svg>
)

// StageCurtains — the Karaoke Night theatre stage, and the stage/background
// picker in Jam and Karaoke.
//
// Four strokes, and that is a budget rather than a style: this icon is drawn
// at 13px in the playlist rows and 16px in the background picker, and the
// previous version put FIVE near-parallel curves plus a dot inside that box
// at stroke-width 2. Below about 20px they merged into a blob. Anything added
// here has to survive 13px — check it there before deciding it looks better.
//
// The scalloped valance is doing the identifying work: an arch reads as a
// door, a framed panel reads as the generic image icon, but a pelmet is a
// theatre and nothing else. The short line between the legs is the stage
// floor, which is what keeps it from reading as a shop awning.
export const StageCurtains: Component<{ size?: number }> = (p) => (
  <svg
    width={p.size ?? 16}
    height={p.size ?? 16}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M3 5h18" />
    <path d="M3 5v3a2.6 2.6 0 0 0 4.5 0 2.6 2.6 0 0 0 4.5 0 2.6 2.6 0 0 0 4.5 0 2.6 2.6 0 0 0 4.5 0V5" />
    <path d="M5 9v12" />
    <path d="M19 9v12" />
    <path d="M9 17h6" />
  </svg>
)

// Copy Icon — duplicate a value to the clipboard
export const Copy: Component<{ size?: number }> = (p) => (
  <svg
    width={p.size ?? 16}
    height={p.size ?? 16}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <rect x="9" y="9" width="12" height="12" rx="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
)

// UserRound Icon — the signed-in account itself
export const UserRound: Component<{ size?: number }> = (p) => (
  <svg
    width={p.size ?? 16}
    height={p.size ?? 16}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21a8 8 0 0 1 16 0" />
  </svg>
)

// UserPlus Icon — add someone as a friend
export const UserPlus: Component<{ size?: number }> = (p) => (
  <svg
    width={p.size ?? 16}
    height={p.size ?? 16}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <line x1="19" y1="8" x2="19" y2="14" />
    <line x1="22" y1="11" x2="16" y2="11" />
  </svg>
)

// Drum (part stem: drums)
export const Drum: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="m2 2 8 8" />
    <path d="m22 2-8 8" />
    <ellipse cx="12" cy="9" rx="10" ry="5" />
    <path d="M7 13.4v7.9" />
    <path d="M12 14v8" />
    <path d="M17 13.4v7.9" />
    <path d="M2 9v8a10 5 0 0 0 20 0V9" />
  </svg>
)

// Guitar (part stem: guitar)
export const Guitar: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="m11.9 12.1 4.514-4.514" />
    <path d="M20.1 2.3a1 1 0 0 0-1.4 0l-1.114 1.114A2 2 0 0 0 17 4.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 17.828 7h1.344a2 2 0 0 0 1.414-.586L21.7 5.3a1 1 0 0 0 0-1.4z" />
    <path d="m6 16 2 2" />
    <path d="M8.2 9.9C8.7 8.8 9.8 8 11 8c2.8 0 5 2.2 5 5 0 1.2-.8 2.3-1.9 2.8l-.9.4A2 2 0 0 0 12 18a4 4 0 0 1-4 4c-3.3 0-6-2.7-6-6a4 4 0 0 1 4-4 2 2 0 0 0 1.8-1.2z" />
  </svg>
)

// Vertical sliders (mixer fader-deck view toggle)
export const SlidersVertical: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <line x1="4" y1="21" x2="4" y2="14" />
    <line x1="4" y1="10" x2="4" y2="3" />
    <line x1="12" y1="21" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12" y2="3" />
    <line x1="20" y1="21" x2="20" y2="16" />
    <line x1="20" y1="12" x2="20" y2="3" />
    <line x1="2" y1="14" x2="6" y2="14" />
    <line x1="10" y1="8" x2="14" y2="8" />
    <line x1="18" y1="16" x2="22" y2="16" />
  </svg>
)

// Stacked rows (mixer compact-list view toggle)
export const ListRows: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <rect x="3" y="4" width="18" height="4" rx="1" />
    <rect x="3" y="10" width="18" height="4" rx="1" />
    <rect x="3" y="16" width="18" height="4" rx="1" />
  </svg>
)

// Audio waveform (part stems: bass / other)
export const AudioWave: Component = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width="24"
    height="24"
  >
    <path d="M2 13a2 2 0 0 0 2-2V7a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0V4a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0v-4a2 2 0 0 1 2-2" />
  </svg>
)

export const LinkChain: Component<{ size?: number }> = (p) => (
  <svg
    width={p.size ?? 14}
    height={p.size ?? 14}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M9 17H7A5 5 0 0 1 7 7h2" />
    <path d="M15 7h2a5 5 0 1 1 0 10h-2" />
    <line x1="8" y1="12" x2="16" y2="12" />
  </svg>
)

export const PowerSymbol: Component<{ size?: number }> = (p) => (
  <svg
    width={p.size ?? 14}
    height={p.size ?? 14}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M18.36 6.64a9 9 0 1 1-12.73 0" />
    <line x1="12" y1="2" x2="12" y2="12" />
  </svg>
)

// The 'i' of an info affordance, drawn rather than typed. A text "i" is
// centred by its line box, not its ink, so it sits off-centre in a round
// button — and it inherits the UI font's italic if anything sets one. The
// ink here spans y 4-20 around x 12, so it is centred by construction.
//
// aria-hidden, unlike its neighbours above: this glyph only ever appears
// inside a button that already carries an aria-label saying what it opens.
export const Info: Component<{ size?: number }> = (p) => (
  <svg
    width={p.size ?? 12}
    height={p.size ?? 12}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.5"
    stroke-linecap="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="4" r="0.5" fill="currentColor" />
    <path d="M12 10v10" />
  </svg>
)

// HelpCircle — "how does this work?": opens a room's guided demo. Labelled
// by its button, so hidden from assistive tech here.
export const HelpCircle: Component<{ size?: number }> = (p) => (
  <svg
    width={p.size ?? 24}
    height={p.size ?? 24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9.5" />
    <path d="M9.4 9.3a2.7 2.7 0 0 1 5.2 1c0 1.8-2.6 2.3-2.6 3.9" />
    <circle cx="12" cy="17.4" r="0.6" fill="currentColor" />
  </svg>
)

// Playback speed — a gauge sweeping from slow to fast with the needle past
// the middle. "1x natural" used to carry this meaning as a word inside every
// dropdown option; the gauge says it once, beside the control, and leaves the
// options to be plain multipliers.
//
// aria-hidden: it labels a select that already names itself.
export const SpeedGauge: Component<{ size?: number }> = (p) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width={p.size ?? 24}
    height={p.size ?? 24}
    aria-hidden="true"
  >
    <path d="M4 18a9 9 0 1 1 16 0" />
    <path d="M12 14l4.5-4" />
    <circle cx="12" cy="14" r="1.4" fill="currentColor" stroke="none" />
  </svg>
)

// Conical flask — the Lab. Marks links into the supporter research surface.
export const Flask: Component<{ size?: number }> = (p) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width={p.size ?? 24}
    height={p.size ?? 24}
    aria-hidden="true"
  >
    <path d="M10 2v6.5L4.7 17.9A2 2 0 0 0 6.4 21h11.2a2 2 0 0 0 1.7-3.1L14 8.5V2" />
    <path d="M8.5 2h7" />
    <path d="M7.3 14h9.4" />
  </svg>
)

// Two devices with an exchange between them — device sync. Marks the
// send/receive surfaces of docs/plans/device-sync.md.
export const DeviceSync: Component<{ size?: number }> = (p) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width={p.size ?? 24}
    height={p.size ?? 24}
    aria-hidden="true"
  >
    <rect x="2" y="5" width="9" height="14" rx="1.5" />
    <rect x="16" y="9" width="6" height="10" rx="1.5" />
    <path d="M13 9.5h2.5" />
    <path d="M14.2 8l1.5 1.5-1.5 1.5" />
  </svg>
)

// Smartphone — "do this on the phone in your hand" (device linking)
export const Smartphone: Component<{ size?: number }> = (p) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width={p.size ?? 24}
    height={p.size ?? 24}
    aria-hidden="true"
  >
    <rect x="6" y="2" width="12" height="20" rx="2.5" />
    <path d="M10.5 18.5h3" />
  </svg>
)

// Key — a passkey. A key rather than a fingerprint on purpose: the credential
// is the thing being listed, and which gesture unlocks it differs per device.
export const Key: Component<{ size?: number }> = (p) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    width={p.size ?? 24}
    height={p.size ?? 24}
    aria-hidden="true"
  >
    <circle cx="7.5" cy="12" r="3.5" />
    <path d="M11 12h10" />
    <path d="M17.5 12v3.5" />
    <path d="M20.5 12v2.5" />
  </svg>
)
